// docs.sentry.io/platforms/javascript/configuration/filtering/ - documentation

export const ignoreList = [
  /h is undefined/,
  /undefined is not an object (evaluating 'h.i')/,
  /Non-Error promise rejection captured with value/,
  // google
  'google is not defined',
  "NotAllowedError: play() failed because the user didn't interact with the document first. https://goo.gl/xX8pDD",
  'Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type',
  'not a LatLng or LatLngLiteral with finite coordinates: in property lat: not a number',
  "Could not load 'util'.",
  //
  "undefined is not an object (evaluating 'k.h')",
  "undefined is not an object (evaluating 'h.l')",
  "undefined is not an object (evaluating 'new oa.up')",
  "undefined is not an object (evaluating 'new oa.tp')",
  "undefined is not an object (evaluating 'new pa.qp')",
  "undefined is not an object (evaluating 'new pa.pp')",
  "undefined is not an object (evaluating 'new pa.op')",
  "undefined is not an object (evaluating 'new pa.pp')",
  "undefined is not an object (evaluating 'new ma.kq')",
  "undefined is not an object (evaluating 'new ma.Gp')",
  "undefined is not an object (evaluating 'new la.Op')",
  "undefined is not an object (evaluating 'new la.Gp')",
  "undefined is not an object (evaluating 'new ja.Eq')",
  //
  "Cannot read properties of undefined (reading 'floatPane')",
  "Cannot read properties of null (reading '__gm')",
  //
  "undefined is not an object (evaluating 'c.fromLatLngToPoint')",
  "undefined is not an object (evaluating 'new ba.Ri')",
  "undefined is not an object (evaluating 'new oa.vp')",
  "null is not an object (evaluating 'f.__gm')",
  //
  'k is undefined',
  'ma is undefined',
  'ja is undefined',
  'e is null',
];
